import { Route, Routes } from 'react-router-dom';

import { AuthInterceptor } from './AuthInterceptor';
import { AuthenticatedRoute } from './AuthenticatedRoute';
import { RepairerOnlyRoute } from './RepairerOnlyRoute';
import { UnauthenticatedRoute } from './UnauthenticatedRoute';
import { Layout } from './Layout';
import { LoginLayout } from './LoginLayout';

import LoginPage from '@/pages/LoginPage/LoginPage';
import ForgotPasswordPage from '@/pages/ForgotPasswordPage/ForgotPasswordPage';
import PasswordResetEmailSentPage from '@/pages/PasswordResetEmailSentPage/PasswordResetEmailSentPage';
import JobsPage from '@/pages/JobsPage/JobsPage';
import NewJobPage from '@/pages/NewJobPage/NewJobPage';
import AdminPage from '@/pages/AdminPage/AdminPage';
import LocationsPage from '@/pages/LocationsPage/LocationsPage';
import PricebooksPage from '@/pages/PricebooksPage/PricebooksPage';
import NotFoundPage from '@/pages/NotFoundPage/NotFoundPage';

export const Router = () => (
    <>
        <AuthInterceptor />
        <Routes>
            <Route element={<UnauthenticatedRoute />}>
                <Route path="/login" element={<LoginLayout />}>
                    <Route index element={<LoginPage />} />
                    <Route path="forgot_password" element={<ForgotPasswordPage />} />
                    <Route
                        path="password_reset_email_sent"
                        element={<PasswordResetEmailSentPage />}
                    />
                </Route>
            </Route>
            <Route element={<AuthenticatedRoute />}>
                <Route path="/" element={<Layout />}>
                    <Route index element={<JobsPage />} />
                    <Route path="new_job" element={<NewJobPage />} />
                    <Route path="jobs" element={<JobsPage />} />
                    <Route path="admin" element={<AdminPage />} />
                    <Route path="locations" element={<LocationsPage />} />
                    <Route element={<RepairerOnlyRoute />}>
                        <Route path="pricebooks" element={<PricebooksPage />} />
                    </Route>
                </Route>
            </Route>
            <Route path="*" element={<NotFoundPage />} />
        </Routes>
    </>
);
